function phoneNumberSanitizer (phoneNum) {
  phoneNum = phoneNum || ''
  const allowedInputCharSequence = phoneNum.replace(/[^\d\+]/g, '')
  const sanitizedPhoneNumAfterSign = allowedInputCharSequence.substr(1).replace(/\+/g, '')
  return `${allowedInputCharSequence.charAt(0)}${sanitizedPhoneNumAfterSign}`
}

export { phoneNumberSanitizer }
